import { normalizeSearch } from "../../../components/utilities/UtilityFunctions";

export const userPlatformSearch = (userList, searchText = "") => {
  if (!searchText || searchText.trim() === "") return userList;
  const searchWordList = normalizeSearch(searchText).split(" ");

  return userList?.filter((user) => {
    const firstName =
      normalizeSearch(user?.firstName) ||
      normalizeSearch(user?.user?.firstName) ||
      "";
    const lastName =
      normalizeSearch(user?.lastName) ||
      normalizeSearch(user?.user?.lastName) ||
      "";
    const teamName =
      normalizeSearch(user?.team?.name) ||
      normalizeSearch(user?.teamName) ||
      "";
    const extendedGroupName = normalizeSearch(user?.extendedGroupName) || "";

    const armyName =
      normalizeSearch(user?.army?.name) ||
      normalizeSearch(user?.armyName) ||
      normalizeSearch(user?.faction?.name) ||
      "";
    const subFactionName = normalizeSearch(user?.subFaction?.name) || "";
    const characterName =
      normalizeSearch(user?.character?.name) ||
      normalizeSearch(user?.characterName) ||
      "";

    let i = 0;
    let result = true;

    while (i < searchWordList?.length && result) {
      if (
        !(
          firstName.includes(searchWordList[i]) ||
          lastName.includes(searchWordList[i]) ||
          extendedGroupName.includes(searchWordList[i]) ||
          teamName.includes(searchWordList[i]) ||
          armyName.includes(searchWordList[i]) ||
          subFactionName.includes(searchWordList[i]) ||
          characterName.includes(searchWordList[i])
        )
      ) {
        result = false;
      }
      i++;
    }

    return result;
  });
};

export const teamPlatformSearch = (teamList, searchText = "") => {
  if (!searchText || searchText.trim() === "") return teamList;
  const searchWordList = normalizeSearch(searchText).split(" ");

  return teamList?.filter((team) => {
    const filteredPlayerList = team?.players
      ? userPlatformSearch(team.players, searchText)
      : [];
    if (filteredPlayerList?.length) return true;

    const teamName = normalizeSearch(team?.name) || "";
    const teamCaptainFirstName =
      normalizeSearch(team?.teamCaptainFirstName) ||
      normalizeSearch(team?.captain?.firstName) ||
      "";
    const teamCaptainLastName =
      normalizeSearch(team?.teamCaptainLastName) ||
      normalizeSearch(team?.captain?.lastName) ||
      "";

    let i = 0;
    let result = true;

    while (i < searchWordList?.length && result) {
      if (
        !(
          teamName.includes(searchWordList[i]) ||
          teamCaptainFirstName.includes(searchWordList[i]) ||
          teamCaptainLastName.includes(searchWordList[i])
        )
      ) {
        result = false;
      }
      i++;
    }

    return result;
  });
};

// Add ability to pass in translation function, if not present original English msg will show
export const getSearchProps = (isTeamEvent = false, t = null) => {
  return {
    label: t
      ? isTeamEvent
        ? t("searchTeamOrPlayer")
        : t("searchPlayer")
      : isTeamEvent
        ? "Search for a team or a player"
        : "Search for a player",
    performSearch: isTeamEvent ? teamPlatformSearch : userPlatformSearch
  };
};
